import { Redirect } from 'umi';
import base64url from 'base64url';
import moment from 'moment';

export default function AuthCheck(props: any) {
  const useAuth = () => {
    const token = localStorage.getItem(TOKEN_NAME);
    if (token && !!token.length) {
      const payload = token.split('.')[1];
      const { exp } = JSON.parse(base64url.decode(payload, 'utf-8'));
      return moment(exp).isAfter(moment().unix());
    }
  };

  if (!useAuth()) {
    localStorage.removeItem(TOKEN_NAME);
    return <Redirect to="/login" />;
  }
  return <div>{props.children}</div>;
}
